/* lp-foa-apply — built by feral·landers. Edit landers/foa-apply/page.js, not this. */
(function(){"use strict";var LP_ROOT="#lp-foa-apply",LP_NAME="foa-apply";
/* ═══════════════════════════════════════════════════════════════════════════
   feral·landers — base.js
   Wrapped in one IIFE by kit/build.mjs, which also injects LP_ROOT and LP_NAME.
   A lander's own page.js runs after this and can use everything below.
   No framework, no modules — this is a theme asset and it has to run alone.
   ═══════════════════════════════════════════════════════════════════════════ */

var LP = {};
var root = document.querySelector(LP_ROOT);
if (!root) return;                       // the section is not on this page

var $  = function (sel, ctx) { return (ctx || root).querySelector(sel); };
var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); };
var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
var isPhone = function () { return window.matchMedia('(max-width: 989px)').matches; };

LP.root = root; LP.$ = $; LP.$$ = $$; LP.reduced = reduced; LP.isPhone = isPhone;

/* Everything the data bridge hands us came out of Shopify admin, where a product
   title legitimately contains & and quotes. Escape before it touches innerHTML. */
function esc(s) {
  return String(s == null ? '' : s)
    .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}
LP.esc = esc;

/* ── THE DATA BRIDGE ──────────────────────────────────────────────────────
   The ~30 lines of Liquid in the section shell emit live product data as JSON:
   variant ids, size labels, availability and PRICES ALREADY RENDERED BY THE
   SERVER in the visitor's market currency.
   🚨 Never format money in here. Shopify does not currency-convert a number you
   typed; the server's string is the only one that is definitely true, and a
   client that cannot convert must do nothing rather than show GBP.
   (part: server-honest-money-fx-upgrade)                                     */
LP.data = (function () {
  var el = document.getElementById('lp-' + LP_NAME + '-data');
  if (!el) return { products: {}, settings: {} };
  try { return JSON.parse(el.textContent); } catch (e) { return { products: {}, settings: {} }; }
})();
LP.product = function (key) { return LP.data.products && LP.data.products[key]; };

document.body.classList.add('lp-live');

/* ── PORTAL ───────────────────────────────────────────────────────────────
   🚨 The lander root sets `overflow-x: clip`, and in Safari ANY ancestor with
   overflow clip/hidden, a transform or a filter kills `position: fixed` — the
   element scrolls with the page. Invisible on desktop Chrome. So anything fixed
   is moved out to <body> before it is ever shown.
   (part: fixed-dock-outside-the-clip-ancestor · portal-overlay-to-body)      */
LP.portal = function (el) { if (el && el.parentNode !== document.body) document.body.appendChild(el); return el; };
$$('[data-lp-portal]').forEach(LP.portal);

/* ── THE THEME CHROME IS A MOVING TARGET ──────────────────────────────────
   Two stacked sticky layers (marquee at top:0, header at top:32px) and the group
   COLLAPSES on scroll: 105px at rest, 73px in motion. A hardcoded number is
   wrong half the time.
   🚨 The collapse is a CSS transition, so it finishes AFTER the last scroll
   event — one reading latches a stale value and a full-height band scrolls
   through the gap. Re-measure at ~200ms and ~500ms after scrolling stops.     */
(function chrome() {
  var group = document.querySelector('.shopify-section-group-header-group') ||
              document.querySelector('#shopify-section-header') ||
              document.querySelector('header');
  if (!group) return;
  var write = function () {
    var b = group.getBoundingClientRect().bottom;
    root.style.setProperty('--lp-chrome', Math.max(0, Math.round(b)) + 'px');
  };
  var t1, t2;
  var onScroll = function () {
    write();
    clearTimeout(t1); clearTimeout(t2);
    t1 = setTimeout(write, 200);
    t2 = setTimeout(write, 500);
  };
  write();
  addEventListener('scroll', onScroll, { passive: true });
  addEventListener('resize', onScroll, { passive: true });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(write);
})();

/* ── REVEALS ──────────────────────────────────────────────────────────────
   Arms only once we know JS is alive, so a script failure leaves a readable
   page rather than a blank one. Nothing in the first viewport is armed: it
   would fade in on load, read as a slow page, and cost LCP on the one element
   that matters most.                                                          */
(function reveals() {
  var items = $$('.lp-rv');
  if (!items.length || !('IntersectionObserver' in window)) return;
  var fold = window.innerHeight;
  var below = items.filter(function (el) { return el.getBoundingClientRect().top > fold * 0.9; });
  if (!below.length) return;
  root.classList.add('is-armed');
  items.forEach(function (el) { if (below.indexOf(el) < 0) el.classList.add('is-in'); });
  if (reduced) { below.forEach(function (el) { el.classList.add('is-in'); }); return; }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('is-in');
      io.unobserve(e.target);
    });
  }, { rootMargin: '0px 0px -12% 0px', threshold: 0.02 });
  below.forEach(function (el) { io.observe(el); });
})();

/* ── THE CART ─────────────────────────────────────────────────────────────
   The proven add-from-anywhere flow, lifted from assets/feral-plp.js.
   🚨 Send it FORM-ENCODED and ask for the drawer sections in the SAME request.
   A JSON body with {items:[…]} genuinely lands the line item and still leaves
   the drawer painting its cached empty state — /cart.js says the item is there
   while the drawer says BAG EMPTY. That is the signature of bypassing the
   section render. (part: cart-add-with-section-rerender)
   The Meta CAPI layer in snippets/feral-events.liquid patches window.fetch and
   fires AddToCart off /cart/add.js by itself — do not emit a second event.    */
var inflight = false;
LP.addToCart = function (items) {
  if (inflight) return Promise.resolve(null);
  inflight = true;
  var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  var fd = new FormData();
  items.forEach(function (it, i) {
    fd.append('items[' + i + '][id]', String(it.id));
    fd.append('items[' + i + '][quantity]', String(it.quantity || 1));
  });
  if (cart && typeof cart.getSectionsToRender === 'function') {
    fd.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }).join(','));
    fd.append('sections_url', window.location.pathname);
    if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
  }
  var url = (window.routes && window.routes.cart_add_url) || '/cart/add';
  return fetch(url, {
    method: 'POST',
    headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
    body: fd
  })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      // Shopify returns a JSON body with `status` for a sold-out variant even
      // when the HTTP status is inconsistently 200.
      if (data.status) throw new Error(data.description || data.message || 'add failed');
      if (cart) {
        // Remove is-empty or the drawer keeps painting its empty state over
        // correct contents. Do NOT open the drawer by hand — renderContents
        // already opens it, and doing both fights the transition.
        if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        if (typeof cart.renderContents === 'function') cart.renderContents(data);
      }
      if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
        window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'lp-' + LP_NAME, cartData: data });
      }
      return data;
    })
    .finally(function () { inflight = false; });
};

/* ── THE SIZE SHEET ───────────────────────────────────────────────────────
   One sheet, portalled to <body>, populated per-call. Mobile gets a bottom
   sheet, desktop the same node centred (CSS decides) — a bottom sheet on a
   1440px screen is a modal for no reason, and an inline shake on a phone
   happens off-screen.
   The sold-out row stays FOCUSABLE and readable rather than disabled: a
   disabled control is invisible to a screen reader's tab order and throws away
   the most valuable moment on the page — someone who wants a thing you do not
   have. (part: the-buy-box-is-one-pill-in-three-states)                       */
var sheet, scrim, lastFocus;
function ensureSheet() {
  if (sheet) return;
  scrim = document.createElement('div');
  scrim.className = 'lp-sheet-scrim';
  sheet = document.createElement('div');
  sheet.className = 'lp-sheet';
  sheet.setAttribute('role', 'dialog');
  sheet.setAttribute('aria-modal', 'true');
  sheet.setAttribute('aria-label', 'Choose a size');
  document.body.appendChild(scrim);
  document.body.appendChild(sheet);
  scrim.addEventListener('click', closeSheet);
  addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSheet(); });
}
function closeSheet() {
  if (!sheet) return;
  sheet.classList.remove('is-open');
  scrim.classList.remove('is-open');
  document.body.classList.remove('lp-locked');
  if (lastFocus && lastFocus.focus) lastFocus.focus();
}
LP.closeSheet = closeSheet;

/**
 * LP.pickSize(productKey, onPick) — onPick(variant) when a size is chosen.
 * Returns false and does nothing if the product is not in the data bridge.
 */
LP.pickSize = function (key, onPick) {
  var p = LP.product(key);
  if (!p) return false;
  ensureSheet();
  lastFocus = document.activeElement;
  var rows = p.variants.map(function (v) {
    var cls = 'lp-sheet__row' + (v.available ? '' : ' is-out');
    var right = v.available
      ? (v.low ? '<span class="lp-sheet__low">low stock</span>' : '')
      : '<span class="lp-sheet__out">sold out</span>';
    return '<button type="button" class="' + cls + '" data-vid="' + v.id + '"' +
           (v.available ? '' : ' data-out="1"') + '>' +
           '<span class="lp-sheet__size">' + esc(v.title) + '</span>' + right + '</button>';
  }).join('');
  sheet.innerHTML =
    '<div class="lp-sheet__head">' +
      '<div><div class="lp-sheet__eyebrow">' + esc(p.eyebrow) + '</div>' +
      '<div class="lp-sheet__title">' + esc(p.title) + '</div></div>' +
      '<button type="button" class="lp-sheet__x" aria-label="Close">&#10005;</button>' +
    '</div>' +
    '<div class="lp-sheet__grid">' + rows + '</div>' +
    '<a class="lp-sheet__link" href="' + esc(p.url) + '">Size guide and full detail &#8599;</a>';
  sheet.querySelector('.lp-sheet__x').addEventListener('click', closeSheet);
  Array.prototype.forEach.call(sheet.querySelectorAll('.lp-sheet__row'), function (b) {
    b.addEventListener('click', function () {
      if (b.getAttribute('data-out')) { window.location.href = p.url; return; }
      var v = p.variants.filter(function (x) { return String(x.id) === b.getAttribute('data-vid'); })[0];
      closeSheet();
      onPick(v);
    });
  });
  scrim.classList.add('is-open');
  sheet.classList.add('is-open');
  if (isPhone()) document.body.classList.add('lp-locked');
  // Focus the DIALOG, not the first size. `.focus()` on a row trips the
  // :focus-visible heuristics even from a tap, so the first size lights up with
  // a ring and reads as already chosen — on the one control where "nothing is
  // chosen yet" is the whole point. (part: size-deselected-until-the-url-picks-one)
  sheet.setAttribute('tabindex', '-1');
  sheet.focus();
  return true;
};

/* ── THE DOCK ─────────────────────────────────────────────────────────────
   Raised once the hero is behind you, so it never covers the first CTA.       */
LP.dockOn = function (afterEl) {
  var dock = document.querySelector('.lp-dock');   // portalled to <body>, so query the document
  if (!dock || !afterEl) return;
  if (!('IntersectionObserver' in window)) { dock.classList.add('is-up'); return; }
  new IntersectionObserver(function (e) {
    dock.classList.toggle('is-up', !e[0].isIntersecting);
  }, { threshold: 0 }).observe(afterEl);
};

/* Smooth in-page jumps that respect reduced motion. */
LP.jumpTo = function (el) {
  if (!el) return;
  el.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
};
$$('[data-lp-jump]').forEach(function (a) {
  a.addEventListener('click', function (e) {
    var target = $(a.getAttribute('data-lp-jump'));
    if (!target) return;
    e.preventDefault();
    LP.jumpTo(target);
  });
});

window.LP = LP;

/* FERAL APPLY — the short application the hiring ad points at.
 *
 * Runs after the kit's base.js (LP, $, $$, root are live). The markup is a real
 * form that posts on its own; this file turns it into one step on screen at a
 * time and takes over the sending.
 *
 * Rules this file keeps (the first four are the long form's, assets/feral-apply.js):
 *  · Never destroy what someone typed. Every answer is kept on this phone for a
 *    week, so a wander off to find a CV, or the ad's browser being closed, loses
 *    nothing but the file. A failed send leaves every step as it was.
 *  · Say what is wrong beside the thing that is wrong, in words, once they have
 *    had a go at it.
 *  · The checks here are a courtesy; the service checks everything again and its
 *    sentence wins.
 *  · An application must not be lost to a bad connection: a failed send is tried
 *    again by itself, every try carries the same random key, and the service
 *    stores it once.
 *  · Nobody is turned away. A "no" moves on to the next step exactly as a "yes"
 *    does, and nothing on the page reacts to which was chosen.
 *  · The phone's own back button goes back one step, not off the page.
 */
var form = $('[data-a-form]');
var done = $('[data-a-done]');
if (!form || !done) return;

var S = LP.data.settings || {};
var MB = 1024 * 1024, MAX_FILE = 8 * MB, MIN_ANSWER = 20;
var EXTS = ['pdf', 'doc', 'docx', 'odt', 'pages', 'rtf', 'txt', 'jpg', 'jpeg', 'png', 'heic'];
var EMAIL = /^[^\s@<>(),;:"[\]\\]+@[^\s@<>(),;:"[\]\\]+\.[^\s@<>(),;:"[\]\\]{2,}$/;
var KEEP = ['commute', 'rtw', 'soon', 'a1', 'a2', 'name', 'email', 'phone', 'location'];
var DRAFT = 'feral-apply-quick:' + (S.job || 'job');
var WEEK = 7 * 24 * 60 * 60 * 1000;
// JUDGED: long enough for a phone to find signal again, short enough that the
// person is still looking at the button.
var RETRY_AFTER = [2000, 5000, 12000];
var PARTS = ['Quick questions', 'Short answers', 'About you'];

var steps = $$('[data-a-step]', form);
var names = steps.map(function (s) { return s.getAttribute('data-a-step'); });
var bar = $('[data-a-bar]'), prog = $('[data-a-prog]'), label = $('[data-a-label]');
var alertBox = $('[data-a-alert]'), sendBtn = $('[data-a-send]'), fill = $('[data-a-fill]'), sendLabel = $('[data-a-send-label]');
var renderedAt = Date.now();
var current = 'intro', touched = {}, sending = false, waitingForNetwork = false, sent = false, depth = 0;

root.classList.add('is-live');
form.noValidate = true;

/* ── THE HEADER'S EDGE ────────────────────────────────────────────────────
   Measured here because the kit's own measurement reads the hidden marquee and
   says 0 on this page (see page.css). Two sticky layers that collapse on scroll
   through a CSS transition, so: now, and again ~200ms and ~500ms after the last
   scroll event. `lift` is only read at the top of the page, where the header's
   overlap of this section is the gap the hidden marquee left. */
var chromeEdge = 105;
(function chrome() {
  var write = function () {
    var edge = 0, groups = document.querySelectorAll('.shopify-section-group-header-group');
    for (var i = 0; i < groups.length; i++) {
      var cs = getComputedStyle(groups[i]);
      if (cs.display === 'none' || (cs.position !== 'sticky' && cs.position !== 'fixed')) continue;
      var r = groups[i].getBoundingClientRect();
      if (r.height > 0 && r.height < 240 && r.bottom > edge) edge = r.bottom;
    }
    chromeEdge = Math.max(0, Math.round(edge));
    root.style.setProperty('--a-chrome', chromeEdge + 'px');
    if (window.pageYOffset < 2) root.style.setProperty('--a-lift', Math.max(0, Math.round(edge - root.getBoundingClientRect().top)) + 'px');
  };
  var t1, t2;
  var soon = function () { write(); clearTimeout(t1); clearTimeout(t2); t1 = setTimeout(write, 200); t2 = setTimeout(write, 500); };
  write();
  addEventListener('scroll', soon, { passive: true });
  addEventListener('resize', soon, { passive: true });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(write);
})();

/* ── WHERE THE LINK CAME FROM ─────────────────────────────────────────────
   Read once, off this page's own address and referrer, and kept with the draft:
   someone who taps the ad today and finishes tomorrow still came from the ad.
   The service decides what to call it; this only reports what it saw. */
function readSource() {
  var out = {};
  try {
    var q = new URLSearchParams(location.search);
    ['src', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_content'].forEach(function (k) { if (q.get(k)) out[k] = q.get(k).slice(0, 120); });
    if (q.get('fbclid')) out.fbclid = true;
    if (document.referrer) {
      var h = new URL(document.referrer).hostname;
      if (h && h !== location.hostname) out.ref = h;
    }
  } catch (e) { /* an old browser: no source, which the service calls direct */ }
  return out;
}
var source = readSource();

/* ── WHAT IS BEING MEASURED ───────────────────────────────────────────────
   The ad can only be tuned towards people who finish if the pixel hears that
   someone did. Shopify's own event bus first (the store's pixels listen there),
   and Meta's standard event when its script is on the page. Never a detail of
   the person: the step's name and nothing else. */
function track(name, data) {
  try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data || {}); } catch (e) { /* not ours to break on */ }
  try { if (window.fbq && name === 'feral_apply_sent') window.fbq('track', 'SubmitApplication'); } catch (e) { /* same */ }
}

/* ── THE FORM'S VALUES ────────────────────────────────────────────────── */
var el = function (n) { return form.elements[n]; };
function val(n) {
  var f = el(n);
  if (!f) return '';
  if (f.length && !f.tagName) {
    for (var i = 0; i < f.length; i++) if (f[i].checked) return f[i].value;
    return '';
  }
  if (f.type === 'checkbox') return f.checked ? f.value : '';
  return f.value;
}
function setVal(n, v) {
  var f = el(n);
  if (!f) return;
  if (f.length && !f.tagName) { for (var i = 0; i < f.length; i++) f[i].checked = f[i].value === v; }
  else f.value = v;
}

/* ── THE DRAFT ────────────────────────────────────────────────────────── */
var saveT;
function save() {
  clearTimeout(saveT);
  saveT = setTimeout(function () {
    if (sent) return;
    try {
      var d = { at: Date.now(), step: current, source: source, f: {} };
      KEEP.forEach(function (k) { d.f[k] = val(k); });
      localStorage.setItem(DRAFT, JSON.stringify(d));
    } catch (e) { /* private mode, or storage full: the form still works */ }
  }, 200);
}
function sendKey() {
  var k = null;
  try { k = localStorage.getItem(DRAFT + ':key'); } catch (e) { k = null; }
  if (k && /^[a-f0-9]{32}$/.test(k)) return k;
  var bytes = new Uint8Array(16);
  if (window.crypto && crypto.getRandomValues) crypto.getRandomValues(bytes);
  else for (var i = 0; i < 16; i++) bytes[i] = Math.floor(Math.random() * 256);
  k = '';
  for (var j = 0; j < 16; j++) k += (bytes[j] < 16 ? '0' : '') + bytes[j].toString(16);
  try { localStorage.setItem(DRAFT + ':key', k); } catch (e) { /* still unique for this page */ }
  return k;
}
function forget() {
  try { localStorage.removeItem(DRAFT); localStorage.removeItem(DRAFT + ':key'); } catch (e) { /* nothing to clear */ }
}

/* ── ERRORS ───────────────────────────────────────────────────────────── */
function errEl(n) { return $('[data-a-err="' + n + '"]'); }
function setErr(n, msg) {
  var e = errEl(n);
  if (!e) return;
  e.textContent = msg || '';
  e.classList.toggle('is-on', !!msg);
  var box = n === 'consent' ? $('.a-check') : (e.closest('.a-field') || e.parentNode.querySelector('.a-field'));
  if (box) box.classList.toggle('is-bad', !!msg);
  var f = el(n);
  if (f && f.tagName) { if (msg) f.setAttribute('aria-invalid', 'true'); else f.removeAttribute('aria-invalid'); }
}
function extOf(file) { var m = /\.([A-Za-z0-9]{1,8})$/.exec(file.name || ''); return m ? m[1].toLowerCase() : ''; }
var checks = {
  commute: function () { return val('commute') ? null : 'Please choose yes or no.'; },
  rtw: function () { return val('rtw') ? null : 'Please choose yes or no.'; },
  soon: function () { return val('soon') ? null : 'Please choose yes or no.'; },
  a1: function () { return answer('a1'); },
  a2: function () { return answer('a2'); },
  name: function () { return val('name').trim().length >= 2 ? null : 'Please tell us your full name.'; },
  email: function () { return EMAIL.test(val('email').trim()) ? null : 'Please enter a valid email address, like name@example.com.'; },
  phone: function () { return (val('phone').match(/[0-9]/g) || []).length >= 7 ? null : 'Please enter a phone number we can call you on.'; },
  location: function () { return val('location').trim() ? null : 'Please tell us where you’re based.'; },
  cv: function () {
    var f = el('cv').files[0];
    if (!f) return 'Please add your CV.';
    if (!f.size) return 'That file is empty. Please choose another.';
    if (EXTS.indexOf(extOf(f)) < 0) return 'We can’t open that type of file. Please use a PDF, a Word document or a photo.';
    if (f.size > MAX_FILE) return 'That file is ' + (f.size / MB).toFixed(1) + ' MB. Please keep your CV under 8 MB: saving it as a PDF usually shrinks it.';
    return null;
  },
  consent: function () { return val('consent') ? null : 'Please tick this box so we can review your application.'; }
};
function answer(n) {
  var len = val(n).trim().length;
  if (!len) return 'Please write a line or two here.';
  return len < MIN_ANSWER ? 'A little more, please: a full sentence at least.' : null;
}
function check(n) { var m = checks[n](); setErr(n, m); return m; }
// What each step must have before the next one opens, in the order it shows them.
var NEEDS = { q1: ['commute'], q2: ['rtw'], q3: ['soon'], a1: ['a1'], a2: ['a2'], you: ['name', 'email', 'phone', 'location'], cv: ['cv', 'consent'] };
var STEP_OF = {};
Object.keys(NEEDS).forEach(function (s) { NEEDS[s].forEach(function (n) { STEP_OF[n] = s; }); });
function stepOk(name) {
  var bad = [];
  (NEEDS[name] || []).forEach(function (n) { touched[n] = true; if (check(n)) bad.push(n); });
  return bad;
}
function focusField(n) {
  var f = el(n);
  if (!f) return;
  if (f.length && !f.tagName) f = f[0];
  if (f.focus) setTimeout(function () { f.focus(); }, 60);
}

/* ── ONE STEP AT A TIME ───────────────────────────────────────────────── */
function stepEl(name) { return name === 'done' ? done : steps[names.indexOf(name)]; }
function paintBar(name) {
  var on = name !== 'intro' && name !== 'done';
  bar.hidden = !on;
  if (!on) return;
  var part = Number(stepEl(name).getAttribute('data-a-part'));
  var segs = $$('i', prog);
  for (var p = 0; p < PARTS.length; p++) {
    var mine = steps.filter(function (s) { return Number(s.getAttribute('data-a-part')) === p; });
    var at = mine.indexOf(stepEl(name));
    // Parts behind are full, parts ahead empty; the one being done is lit to the
    // end of the step on screen, so the bar has always moved by the time it is read.
    segs[p].style.setProperty('--a-f', p < part ? 1 : p > part ? 0 : (at + 1) / mine.length);
  }
  prog.setAttribute('aria-valuenow', String(part + 1));
  prog.setAttribute('aria-valuetext', 'Part ' + (part + 1) + ' of ' + PARTS.length + ': ' + PARTS[part]);
  label.textContent = (part + 1) + ' of ' + PARTS.length;
}
function show(name, opts) {
  opts = opts || {};
  if (names.indexOf(name) < 0 && name !== 'done') name = 'intro';
  current = name;
  steps.forEach(function (s) { s.classList.toggle('is-on', s === stepEl(name)); });
  done.classList.toggle('is-on', name === 'done');
  done.hidden = name !== 'done';
  form.hidden = name === 'done';
  paintBar(name);
  // Each step starts at its top, under the header, wherever the last one was left.
  if (!opts.quiet) {
    // Each step is one screen, so it starts from the very top of the page, where the
    // header is at rest and --a-lift has it clear of the first line.
    if (window.pageYOffset > 0) window.scrollTo(0, 0);
    var target = stepEl(name).querySelector('textarea, .a-input') || stepEl(name).querySelector('.a-q');
    if (name === 'cv' || name === 'intro') target = stepEl(name).querySelector('.a-q');
    if (name === 'done') target = done;
    // Focus inside the tap that brought us here, or iOS will not raise the keyboard.
    if (target && target.focus) { try { target.focus({ preventScroll: true }); } catch (e) { target.focus(); } }
  }
  save();
}
function go(name) {
  depth++;
  try { history.pushState({ a: name }, ''); } catch (e) { depth--; }
  show(name);
  track('feral_apply_step', { step: name });
}
function next() {
  var bad = stepOk(current);
  if (bad.length) { focusField(bad[0]); return; }
  var i = names.indexOf(current);
  if (i < names.length - 1) go(names[i + 1]);
}
function back() {
  if (sending) return;
  if (depth > 0) { history.back(); return; }
  // Opened part-way through from a kept draft: there is no page history behind this step.
  var i = names.indexOf(current);
  var to = names[Math.max(0, i - 1)];
  try { history.replaceState({ a: to }, ''); } catch (e) { /* not fatal */ }
  show(to);
}
addEventListener('popstate', function (e) {
  if (depth > 0) depth--;
  if (sent) { show('done', { quiet: true }); return; }
  if (sending) return;
  show((e.state && e.state.a) || 'intro');
});

$('[data-a-start]').addEventListener('click', function (e) {
  e.preventDefault();
  track('feral_apply_start', {});
  if (!resumeAt) { go('q1'); return; }
  // A kept draft: lay the steps before it into the history too, so "back" from
  // where they left off is the step before it, not the top of the page.
  var upTo = names.indexOf(resumeAt);
  for (var i = 1; i < upTo; i++) { try { history.pushState({ a: names[i] }, ''); depth++; } catch (err) { break; } }
  go(resumeAt);
});
$('[data-a-back]').addEventListener('click', back);
$$('[data-a-next]').forEach(function (b) { b.addEventListener('click', next); });

// The three questions: one tap answers and moves on. A click, not a change, so
// tapping the answer already chosen (after coming back) moves on too.
$$('.a-opt input').forEach(function (input) {
  input.addEventListener('click', function () {
    var name = input.name;
    setErr(name, null);
    save();
    var at = current;
    setTimeout(function () { if (current === at && STEP_OF[name] === at) next(); }, LP.reduced ? 0 : 190);
  });
});

/* ── THE WRITTEN ANSWERS ──────────────────────────────────────────────── */
function count(n) {
  var c = $('[data-a-n="' + n + '"]');
  if (c) c.textContent = val(n).length + ' / 300';
}
// A mistyped address is the one mistake that makes a good application unanswerable.
// Offered, never applied for them.
var TYPOS = {
  'gmial.com': 'gmail.com', 'gmai.com': 'gmail.com', 'gmal.com': 'gmail.com', 'gnail.com': 'gmail.com', 'gmail.co': 'gmail.com',
  'gmail.con': 'gmail.com', 'gmail.cm': 'gmail.com', 'gmaill.com': 'gmail.com', 'hotmial.com': 'hotmail.com', 'hotmai.com': 'hotmail.com',
  'hotmail.con': 'hotmail.com', 'hotmail.co': 'hotmail.co.uk', 'hotmail.couk': 'hotmail.co.uk', 'outlok.com': 'outlook.com',
  'outlook.con': 'outlook.com', 'icloud.con': 'icloud.com', 'icloud.co': 'icloud.com', 'iclould.com': 'icloud.com', 'icoud.com': 'icloud.com',
  'yahoo.con': 'yahoo.com', 'yaho.com': 'yahoo.com', 'yahoo.couk': 'yahoo.co.uk', 'live.couk': 'live.co.uk', 'btinternet.con': 'btinternet.com'
};
var hint = $('[data-a-email-hint]'), fix = $('[data-a-email-fix]');
function emailHint() {
  var v = val('email').trim(), at = v.lastIndexOf('@');
  var better = at > 0 ? TYPOS[v.slice(at + 1).toLowerCase()] : null;
  hint.hidden = !better;
  if (better) fix.textContent = v.slice(0, at + 1) + better;
}
fix.addEventListener('click', function () {
  setVal('email', fix.textContent);
  hint.hidden = true;
  touched.email = true; check('email'); save();
});
form.addEventListener('focusout', function (e) {
  var n = e.target.name;
  if (n === 'email') emailHint();
  if (!checks[n] || !e.target.value || e.target.type === 'radio' || e.target.type === 'file') return;
  touched[n] = true;
  check(n);
});
form.addEventListener('input', function (e) {
  var n = e.target.name;
  if (n === 'a1' || n === 'a2') count(n);
  if (touched[n] && checks[n]) check(n);
  if (n === 'email' && !hint.hidden) emailHint();
  save();
});
form.addEventListener('change', function (e) {
  if (e.target.name === 'consent') { touched.consent = true; check('consent'); }
});
// Enter in a one-line field moves on; it never sends a half-finished form.
form.addEventListener('keydown', function (e) {
  if (e.key !== 'Enter' || !e.target.classList || !e.target.classList.contains('a-input')) return;
  e.preventDefault();
  var list = NEEDS[current] || [], i = list.indexOf(e.target.name);
  if (i > -1 && i < list.length - 1) focusField(list[i + 1]); else next();
});

/* ── THE CV ───────────────────────────────────────────────────────────── */
(function file() {
  var field = $('[data-a-file]'), input = el('cv'), drop = $('[data-a-drop]'), card = $('[data-a-card]');
  var paint = function () {
    var f = input.files[0];
    drop.hidden = !!f;
    card.hidden = !f;
    if (f) {
      $('[data-a-fname]', field).textContent = f.name;
      $('[data-a-fsize]', field).textContent = f.size < MB ? Math.max(1, Math.round(f.size / 1024)) + ' KB' : (f.size / MB).toFixed(1) + ' MB';
      $('[data-a-ext]', field).textContent = (extOf(f) || 'FILE').toUpperCase().slice(0, 4);
    }
    touched.cv = true;
    check('cv');
  };
  input.addEventListener('change', paint);
  $('[data-a-remove]', field).addEventListener('click', function () {
    input.value = '';
    drop.hidden = false; card.hidden = true;
    setErr('cv', null);
  });
  var over = 0;
  drop.addEventListener('dragenter', function (e) { e.preventDefault(); over++; drop.classList.add('is-over'); });
  drop.addEventListener('dragover', function (e) { e.preventDefault(); });
  drop.addEventListener('dragleave', function () { if (--over <= 0) { over = 0; drop.classList.remove('is-over'); } });
  drop.addEventListener('drop', function (e) {
    e.preventDefault(); over = 0; drop.classList.remove('is-over');
    var files = e.dataTransfer && e.dataTransfer.files;
    if (!files || !files.length) return;
    try { var dt = new DataTransfer(); dt.items.add(files[0]); input.files = dt.files; } catch (err) { return; }
    paint();
  });
  // A file dropped anywhere else on the page must not navigate away from it.
  addEventListener('dragover', function (e) { if (e.target.closest && !e.target.closest('[data-a-drop]')) e.preventDefault(); });
  addEventListener('drop', function (e) { if (e.target.closest && !e.target.closest('[data-a-drop]')) e.preventDefault(); });
})();

/* ── SEND ─────────────────────────────────────────────────────────────── */
var key = sendKey();
function say(msg) { alertBox.textContent = msg || ''; alertBox.hidden = !msg; }
function busy(on, pct) {
  sending = on;
  sendBtn.setAttribute('aria-busy', on ? 'true' : 'false');
  sendBtn.disabled = on;
  fill.style.width = on ? (pct || 0) + '%' : '0';
  if (!on) sendLabel.textContent = 'Send application';
  else if (pct >= 100) sendLabel.textContent = 'Almost there…';
  else sendLabel.textContent = pct ? 'Sending… ' + pct + '%' : 'Sending…';
}
function build() {
  var fd = new FormData();
  fd.append('job', S.job || val('job'));
  fd.append('job_title', S.jobTitle || val('job_title'));
  fd.append('form', 'quick');
  ['commute', 'rtw', 'soon'].forEach(function (k) { fd.append(k, val(k)); });
  ['a1', 'a2', 'name', 'email', 'phone', 'location'].forEach(function (k) { fd.append(k, val(k).trim()); });
  fd.append('consent', 'yes');
  fd.append('website', val('website'));
  // How long the page had been open, counted here: the service never compares
  // its clock with the phone's.
  fd.append('el', String(Date.now() - renderedAt));
  fd.append('key', key);
  fd.append('source', JSON.stringify(source));
  fd.append('cv', el('cv').files[0]);
  return fd;
}
// attempt 0 is the person pressing the button; 1..3 are ours.
function post(attempt) {
  var xhr = new XMLHttpRequest();
  // Read off the form each time: the address is the markup's, never the URL's.
  xhr.open('POST', form.getAttribute('action'), true);
  xhr.timeout = 5 * 60 * 1000;
  xhr.upload.onprogress = function (ev) {
    if (ev.lengthComputable) busy(true, Math.min(100, Math.round((ev.loaded / ev.total) * 100)));
  };
  var dropped = function () {
    if (attempt < RETRY_AFTER.length) {
      busy(true, 0);
      sendLabel.textContent = 'Connection dropped. Trying again…';
      setTimeout(function () { post(attempt + 1); }, RETRY_AFTER[attempt]);
      return;
    }
    busy(false);
    waitingForNetwork = true;
    say(navigator.onLine === false
      ? 'You’re offline. Keep this page open: we’ll send your application the moment you’re back online. Nothing you’ve entered has been lost.'
      : 'We couldn’t reach FERAL. Please check your connection and press send again. Nothing you’ve entered has been lost.');
  };
  xhr.onload = function () {
    var body = null;
    try { body = JSON.parse(xhr.responseText); } catch (err) { body = null; }
    if (xhr.status === 201 && body && body.ok) return success(body.ref);
    if (!body && (xhr.status === 0 || xhr.status >= 500)) return dropped();
    busy(false);
    var msg = (body && body.error) || 'Something went wrong on our side. Please try again in a minute.';
    var at = body && body.field && STEP_OF[body.field];
    if (at && errEl(body.field)) {
      // The service's sentence, beside the thing it is about, on the step that holds it.
      if (at !== current) go(at);
      touched[body.field] = true;
      setErr(body.field, msg);
      focusField(body.field);
    } else {
      say(msg + ' Nothing you’ve entered has been lost.');
    }
  };
  xhr.onerror = dropped;
  xhr.ontimeout = dropped;
  busy(true, 0);
  try { xhr.send(build()); } catch (err) { dropped(); }
}
function trySend() {
  if (sending || sent) return;
  waitingForNetwork = false;
  say('');
  // Every step again, in order: a draft opened part-way through may have skipped one.
  for (var i = 1; i < names.length; i++) {
    var bad = stepOk(names[i]);
    if (bad.length) {
      if (names[i] !== current) go(names[i]);
      focusField(bad[0]);
      return;
    }
  }
  post(0);
}
form.addEventListener('submit', function (e) { e.preventDefault(); if (current === 'cv') trySend(); else next(); });
addEventListener('online', function () { if (waitingForNetwork && !sending && !sent) trySend(); });
addEventListener('beforeunload', function (e) { if (sending) { e.preventDefault(); e.returnValue = ''; } });

function success(ref) {
  sent = true;
  forget();
  var first = val('name').trim().split(/\s+/)[0];
  $('[data-a-first]', done).textContent = first ? ', ' + first : '';
  $('[data-a-ref]', done).textContent = ref || '';
  busy(false);
  try { history.replaceState({ a: 'done' }, ''); } catch (e) { /* not fatal */ }
  show('done');
  track('feral_apply_sent', {});
}

/* ── COMING BACK ──────────────────────────────────────────────────────────
   Answers kept from an earlier visit are put back and the button says so. The
   CV cannot be kept, so nobody is dropped further in than the step before it. */
var resumeAt = null;
(function restore() {
  var d = null;
  try { d = JSON.parse(localStorage.getItem(DRAFT) || 'null'); } catch (e) { d = null; }
  if (!d || !d.f || !(Date.now() - d.at < WEEK)) { if (d) forget(), key = sendKey(); return; }
  KEEP.forEach(function (k) { if (d.f[k]) setVal(k, d.f[k]); });
  // First touch wins: the visit that came from the ad is the one that counts.
  if (d.source && Object.keys(d.source).length) source = d.source;
  var i = names.indexOf(d.step);
  if (i > 0) {
    resumeAt = names[i];
    $('[data-a-start]').firstChild.nodeValue = 'Carry on where you left off';
    $('[data-a-start-note]').textContent = 'We kept your answers on this phone.';
  }
})();
count('a1'); count('a2');
try { history.replaceState({ a: 'intro' }, ''); } catch (e) { /* not fatal */ }
show('intro', { quiet: true });

})();